import { useCallback, useEffect, useState } from 'react';

export function useCustomer(customer, store) {
  const { getGoogleCustomers, getGoogleConversionActions } = store
  const [customerId, setCustomerId] = useState(null)
  const [conversionActionId, setConversionActionId] = useState(null)
  const [credential, setCredential] = useState(null)
  const [details, setDetails] = useState(null);
  const [user, setUser] = useState(null);
  const [customers, setCustomers] = useState(null);
  const [conversionActions, setConversionActions] = useState(null)
  const [customersOptions, setCustomersOptions] = useState(null)
  const [conversionActionOptions, setConversionActionOptions] = useState(null)

  const loadCustomers = useCallback(async () => {
    if (credential) {
      setCustomers(null)
      const customers = await getGoogleCustomers(credential)
      setCustomers(customers)
    }
  }, [credential, getGoogleCustomers])

  const loadConversionActions = useCallback(async () => {
    if (credential && customerId) {
      setConversionActions(null)
      const conversionActions = await getGoogleConversionActions(credential, customerId)
      setConversionActions(conversionActions)
    }
  }, [credential, customerId, getGoogleConversionActions])

  {
    const { customerId, conversionActionId, user, details, credential, customers, conversionActions } = customer || {}
    useEffect(() => {
      if (credential) {
        setCredential(credential)
      }
    }, [credential])

    useEffect(() => {
      if (user) {
        setUser(user)
      }
    }, [user])

    useEffect(() => {
      if (details) {
        setDetails(details)
      }
    }, [details])

    useEffect(() => {
      if (customers) {
        setCustomers(customers)
      }
    }, [customers])

    useEffect(() => {
      if (conversionActions) {
        setConversionActions(conversionActions)
      }
    }, [conversionActions])

    useEffect(() => {
      if (customerId) {
        setCustomerId(customerId)
      }
    }, [customerId])

    useEffect(() => {
      if (conversionActionId) {
        setConversionActionId(conversionActionId)
      }
    }, [conversionActionId])
  }

  useEffect(() => {
    !customers && loadCustomers()
  }, [loadCustomers, customers])

  useEffect(() => {
    !conversionActions && loadConversionActions()
  }, [loadConversionActions, conversionActions])

  useEffect(() => {
    setCustomersOptions(customers ? customers.map(({ id, name, timezone, currencyCode }) => ({
      value: id,
      label: `[#${id.replace(/(\d{3})(\d{3})(\d{4})/g, '$1-$2-$3')}] ${name || '<Unnamed>'}`,
      details: { id, timezone, currencyCode },
    })) : null)
  }, [customers])

  useEffect(() => {
    setConversionActionOptions(conversionActions ? conversionActions.map(({ id, name }) => ({
      value: id,
      label: name || '<Unnamed>',
    })) : null)
  }, [conversionActions])

  const onChange = data => {
    const { credential = null, user = null } = data || {}

    setCredential(credential)
    setUser(user)

    if (credential) {
      loadCustomers()
    }

    if (!data) {
      setCustomerId(null)
      setConversionActionId(null)
      setDetails(null)
      setCustomers(null)
      setConversionActions(null)
    }
  }

  const onChangeCustomer = option => {
    const { value = null, details = null } = option || {}
    setCustomerId(value)
    setDetails(details)
    setConversionActionId(null)
    setConversionActions(null)
  }

  const onChangeConversionAction = option => {
    setConversionActionId(option?.value || null)
  }

  return {
    customerId,
    conversionActionId,
    credential,
    user,
    customers,
    details,
    customersOptions,
    conversionActions,
    conversionActionOptions,
    loadConversionActions,
    loadCustomers,
    setCustomerId,
    onChange,
    onChangeCustomer,
    onChangeConversionAction,
  }
}
